import axios from "../utils/axios";

class FleetService {
    // Dashboard
    getDashboard(queryString)           { return axios.get(`fleetDashboard${queryString ? '?' + queryString : ''}`); }
    getVehicleDetail(id)            { return axios.get(`vehicleDetail/${id}`); }

    // Assignment helpers
    getVehiclesList()               { return axios.get("fleet/vehiclesList"); }
    getDriversList()                { return axios.get("fleet/driversList"); }
    checkAssignment(params)         { return axios.get("fleet/checkAssignment", { params }); }

    // Assignments
    getAssignments(vehicleId)       { return axios.get(`vehicleAssignments/${vehicleId}`); }
    getDriverAssignments(userId)    { return axios.get(`driverAssignments/${userId}`); }
    assignVehicle(data)             { return axios.post("assignVehicle", data); }
    endAssignment(id)               { return axios.put(`endAssignment/${id}`); }
    getUnassigned()                 { return axios.get("unassignedVehicles"); }

    // Trip / fuel logs
    getTripLogs(vehicleId)          { return axios.get(`tripLogs/${vehicleId}`); }
    getAllTripLogs(params)           { return axios.get("tripLogs", { params }); }
    saveTripLog(data)               { return axios.post("saveTripLog", data); }

    // Documents
    getDocuments(vehicleId)         { return axios.get(`vehicleDocuments/${vehicleId}`); }
    saveDocument(data)              { return axios.post("saveVehicleDocument", data); }
    deleteDocument(id)              { return axios.post("deleteVehicleDocument", { id }); }
    getExpiringDocuments(days = 60) { return axios.get("expiringDocuments", { params: { days } }); }

    // Costs / maintenance
    getCosts(vehicleId)             { return axios.get(`vehicleCosts/${vehicleId}`); }
    saveCost(data)                  { return axios.post("saveVehicleCost", data); }

    // Incidents
    getIncidents()                  { return axios.get("fleet/incidents"); }
    getIncident(id)                 { return axios.get(`fleet/incident/${id}`); }
    saveIncident(data)              { return axios.post("fleet/saveIncident", data); }
    deleteIncident(id)              { return axios.post("fleet/deleteIncident", { id }); }

    // Disposals
    getDisposals()                  { return axios.get("fleet/disposals"); }
    saveDisposal(data)              { return axios.post("fleet/saveDisposal", data); }
    approveDisposalHOD(id)          { return axios.put(`fleet/approveDisposalHOD/${id}`); }
    approveDisposalDirector(id)     { return axios.put(`fleet/approveDisposalDirector/${id}`); }
    markDisposed(id)                { return axios.put(`fleet/markDisposed/${id}`); }

    // Reports
    reportServiceDue(days = 30)     { return axios.get("report/vehiclesDueForService", { params: { days } }); }
    reportLifespan()                { return axios.get("report/lifespanExpiry"); }
    reportChronic(months, min)      { return axios.get("report/chronicBreakdowns", { params: { months, min_repairs: min } }); }
    reportDrivers()                 { return axios.get("report/driverAssignment"); }
    reportTCO()                     { return axios.get("report/totalCostOfOwnership"); }
    reportDocs()                    { return axios.get("report/documentCompliance"); }
    reportStatus()                  { return axios.get("report/fleetStatus"); }
    reportFuel()                    { return axios.get("report/fuelConsumption"); }
    reportAgeing()                  { return axios.get("report/ageingFleet"); }

    // ── Compliance Audit Log ────────────────────────────────────────────────
    getAuditLog(params)             { return axios.get("fleet/auditLog", { params }); }
    getVehiclesWithNoTrips()        { return axios.get("fleet/vehiclesWithNoTrips"); }
    getProgrammes()                 { return axios.get("fleet/programmes"); }

    // Vehicle history & stats
    getStatusHistory(assetId)       { return axios.get(`fleet/statusHistory/${assetId}`); }
    getVehicleDeployStats(assetId)  { return axios.get(`fleet/vehicleDeploymentStats/${assetId}`); }

    // Deployments
    getDeployments()                { return axios.get('fleet/deployments'); }
    saveDeployment(data)            { return axios.post('fleet/saveDeployment', data); }
    returnDeployment(id)            { return axios.put(`fleet/returnDeployment/${id}`); }
    returnVehicle(data)             { return axios.post('fleet/returnVehicle', data); }
    deleteDeployment(id)            { return axios.delete(`fleet/deleteDeployment/${id}`); }

    // Excel export
    getExportData()                 { return axios.get("fleet/exportData"); }
    getFuelBalanceSummary(params={})       { return axios.get('fleet/fuelBalanceSummary', { params }); }
    getFuelTopups(vehicle_id='')           { return axios.get('fleet/getFuelTopups', { params: { vehicle_id } }); }
    saveFuelTopup(data)                    { return axios.post('fleet/saveFuelTopup', data); }
    deleteFuelTopup(id)                    { return axios.post('fleet/deleteFuelTopup', { id }); }
    setVehicleInitialFuel(vehicle_id, lvl) { return axios.post('fleet/setVehicleInitialFuel', { vehicle_id, initial_fuel_level: lvl }); }
}

export default new FleetService();